<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="6">
        <v-menu
                v-model="menu_dia"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDia"
                    label="Dia"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dia" @input="dataAlterada()" locale="pt-br"></v-date-picker>
              </v-menu>
      </v-col>
      <v-col cols="12" sm="6">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Data</th>
          <th>Horário</th>
          <th>Origem</th>
          <th>Destino</th>
          <th>Tarifa</th>
          <th>Tempo</th>
          <th>Valor</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.time | formatDate }}</td>
          <td>{{ item.time | formatTime }}</td>
          <td>{{ item.from }}</td>
          <td>{{ item.to }}</td>
          <td>{{ item.pricePerMinute | formatRate }}</td>
          <td>{{ item.billSecondsRounded }}</td>
          <td>{{ item.value | formatRate }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: null,
    dia: null,
    menu_dia: false
  }),
  created: function() {
    var hoje = new Date();
    this.dia = "" + hoje.getFullYear() + "-" + (hoje.getMonth()+1) + "-" + hoje.getDate();
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/call/vn/"+this.$route.params.id+"/"+this.dia, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.current = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    view: function(id) {
      router.push({ path: `/log/${id}` });
    },
    register: function (){
      router.push({path: "/log/0"});
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    dataAlterada: function () {
      this.menu_dia = false;
      this.list();
    }
  },
  computed: {
    computedDia() {
      return this.formatDate(this.dia);
    }
  }
};
</script>